import * as React from "react";
import { useRouter } from "next/router";
import { IGroup } from "@nju/data-access-portal-dashboard";
import { useOrchestrators } from "@nju/data-access-portal-orchestrator";
import { IInternet, IMobileAccess } from "@nju/data-access-portal-product";
import { IClientAddress } from "@nju/data-access-sales-client";
import { salesRoutes } from "@nju/routes";
import { copyToClipboard } from "@nju/utils";
import type { IPhaseProps } from "../partials/types";
import { CustomerStatusFtthProductCard } from "./CustomerStatusFtthProductCard";
import { CustomerStatusMobileProductCard } from "./CustomerStatusMobileProductCard";

export interface ICustomerStatusBannerProps {
  ftthPhase: IPhaseProps;
  mobilePhase: IPhaseProps;
  groups: IGroup[] | undefined;
  internet: IInternet | undefined;
  mobileAccess: IMobileAccess | undefined;
  handleRedirectFtth: () => void;
  handleBlockFtth: () => void;
  handleRedirectMobile: () => void;
  isAddressInFtthRange: boolean;
  address: IClientAddress | undefined;
  onUpdateAddress: () => void;
}

export function CustomerStatusBanner({
  groups,
  ftthPhase,
  mobilePhase,
  mobileAccess,
  internet,
  handleRedirectFtth,
  handleBlockFtth,
  handleRedirectMobile,
  isAddressInFtthRange,
  address,
  onUpdateAddress,
}: ICustomerStatusBannerProps) {
  const router = useRouter();
  const { ftth } = useOrchestrators();

  const handleRedirectDetails = () => {
    return router.push(salesRoutes.statusKlientaSzczegoly.get());
  };

  const handleCopyToClipboard = React.useCallback(async (text: string) => {
    await copyToClipboard(text);
  }, []);

  return (
    <div className="grid gap-4 grid-cols-none from-desktop:grid-cols-2">
      <CustomerStatusFtthProductCard
        address={address}
        ftth={ftth}
        handleBlockFtth={handleBlockFtth}
        handleCopyToClipboard={handleCopyToClipboard}
        handleRedirectFtth={handleRedirectFtth}
        internet={internet}
        isAddressInFtthRange={isAddressInFtthRange}
        onUpdateAddress={onUpdateAddress}
        phase={ftthPhase}
      />
      <CustomerStatusMobileProductCard
        groups={groups}
        handleRedirectDetails={handleRedirectDetails}
        handleRedirectMobile={handleRedirectMobile}
        mobileAccess={mobileAccess}
        phase={mobilePhase}
      />
    </div>
  );
}
